import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Flujo de Compra" },
  // { label: "Ordenes de Compra", icon: "fas fa-shopping-basket", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoOrdenesCompra", desc: "Gestión de órdenes",   perm: "menu_oc"       },
  // { label: "Embarques",          icon: "fas fa-ship",            color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoEmbarques",    desc: "Control de embarques",  perm: "embarques"          },
  { label: "Proveedores (No usar)",              icon: "fas fa-dolly", color: "#64748b", bg: "#f8fafc", href: "/Proveedores",             desc: "Catálogo de proveedores",  perm: "menu_proveedores" },
  // { label: "Compra",    icon: "fas fa-bolt",            color: "#f43f5e", bg: "#fff1f2", href: "/CompraDirectaCreate",  desc: "Entrada en un paso", perm: "menu_compras" },
  { label: "Entrada de Mercancía",          icon: "fas fa-cart-plus",       color: "#10b981", bg: "#f0fdf4", href: "/ListadoCompras",       desc: "Entradas a almacén",   perm: "menu_compras"  },
  { label: "Reporte de Compras",           icon: "fas fa-file-invoice",    color: "#6366f1", bg: "#eef2ff", href: "/ReporteCompras",       desc: "Compras con costo y total", perm: "inventarios_costosAdmin" },

  // { type: "section", label: "Seguimiento de Pedidos" },
  // { label: "Pendiente Embarcar", icon: "fas fa-plane-departure", color: "#f97316", bg: "#fff7ed", href: "/ListadoPendEmbarcar", desc: "Pendiente de embarcar", perm: "pendiente_embarcar" },
  // { label: "Pendiente Recibir",  icon: "fas fa-plane-arrival",   color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendRecibir",  desc: "Pendiente de recibir",  perm: "pendiente_recibir"  },

  // { type: "section", label: "Planeación de Reabasto" },
  // { label: "Reabasto",           icon: "fas fa-warehouse", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoReabasto", desc: "Análisis de reabasto",   perm: "menu_compras" },
  // { label: "Sugerido de Reabasto", icon: "fas fa-sync",    color: "#6366f1", bg: "#eef2ff", href: "/ListadoRotacion", desc: "Rotación y reposición",  perm: "menu_compras" },

  // { type: "section", label: "Seguimiento" },
  // { label: "Tracking Compras",   icon: "fas fa-search", color: "#14b8a6", bg: "#f0fdfa", href: "/ListadoTrackingCompras", desc: "Seguimiento de compras", perm: "seguimiento_inventarios" },

  // { type: "section", label: "Catálogos" },
  // { label: "Proveedores",              icon: "fas fa-dolly", color: "#64748b", bg: "#f8fafc", href: "/Proveedores",             desc: "Catálogo de proveedores",  perm: "menu_proveedores" },
  // { label: "Conceptos Gastos Embarque", icon: "fas fa-bars", color: "#ec4899", bg: "#fdf2f8", href: "/ConceptosGastosEmbarques", desc: "Conceptos de gastos",     perm: "menu_compras"     },
  // { label: "Navieras",                 icon: "fas fa-ship", color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoNavieras",        desc: "Catálogo de navieras",     perm: "menu_compras"     },
];

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-shopping-cart" color="#3b82f6" bg="#eff6ff" title="Compras" subtitle="Órdenes de compra y entradas de mercancía" />
        {user.menu_compras ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCompras;
